import React from "react";
import { useNavigate } from "react-router-dom";
import { SignupFlow } from "../components/SignupFlow";
import { ROUTES } from "../../../shared/utils";

export const Signup: React.FC = () => {
  const navigate = useNavigate();

  return <SignupFlow onBackToLogin={() => navigate(ROUTES.LOGIN)} />;
};
